module.exports = __webpack_public_path__ + "static/media/weekly-report-icon-active.67c03843.svg";